import Tippy from '@tippyjs/react';

import { useIsShellHosted, useShellChrome } from 'lib/context/ShellContext/ShellContext';

import Icon from 'components/shared/Icon/Icon';

const ChromeInfo = () => {
  const isHosted = useIsShellHosted();
  const { description } = useShellChrome() || {};

  if (!isHosted || !description) return null;

  return (
    <Tippy content={description} className="tippy-dark" placement="bottom" maxWidth={320}>
      <span
        className="flex size-5 shrink-0 cursor-default items-center justify-center"
        aria-label={description}
        data-qa="page-info">
        <Icon icon="info-circle-mono" size={14} color="neutral" shade={400} />
      </span>
    </Tippy>
  );
};

export default ChromeInfo;
